import axIos from "@/common/axios";
import * as api from "@/api";
let axios = axIos.instance1;
let axios2 = axIos.instance2;
let axios3 = axIos.instance3;
let axios4 = axIos.instance4;

// Function
//退出登录
//  export  default{
//    loginOut(){
//     return new Promise((resolve,reject) => {
//         axios.post(api.loginOut, param).then(res => {
//             console.log("获取token?");
//             resolve(res.data);
//         })
//     })
//   }
//  }

//扫码包配置文件
export function qrcode_config(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.qrcode_config, param).then((res) => {
			resolve(res.data);
		});
	});
}

//扫码版游戏列表
export function qrcode_game_list(param) {
	return new Promise((resolve, reject) => {
		axios2.get(api.qrcode_game_list, param).then((res) => {
			resolve(res.data);
		});
	});
}

//扫码版xubei游戏列表
export function qrcode_xubei_game_list(param) {
	return new Promise((resolve, reject) => {
		axios2.get(api.qrcode_xubei_game_list, param).then((res) => {
			resolve(res.data);
		});
	});
}

//扫码版游戏价格配置
export function qrcode_game_price_config(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.qrcode_game_price_config, param).then((res) => {
			resolve(res.data);
		});
	});
}

export function loginOut(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.loginOut, param).then((res) => {
			resolve(res.data);
		});
	});
}
//商品
export function goodList(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.goodList, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 添加商品addGood
export function addGood(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.addGood, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 删除商品
export function deleGood(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.deleGood, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 网吧列表
export function bar_list(param) {
	return new Promise((resolve, reject) => {
		console.log(axios);
		axios.post(api.bar_list, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 网吧台数
export function bar_num(param) {
	return new Promise((resolve, reject) => {
		console.log(axios);
		axios.get(api.bar_num, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 包月订单
export function month_order(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.month_order, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 扫码订单
export function month_sao(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.month_sao, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 手机版订单
export function mobile_order(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.mobile_order, param).then((res) => {
			resolve(res.data);
		});
	});
}
//条件查询next_search
export function searchList(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.searchList, param).then((res) => {
			resolve(res.data);
		});
	});
}
//下级代理商条件查询next_tj
export function next_search(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.next_search, param).then((res) => {
			resolve(res.data);
		});
	});
}
//下级代理商条件查询统计
export function next_tj(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.next_tj, param).then((res) => {
			resolve(res.data);
		});
	});
}
//管理员账户禁用删除
export function dele_use(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.dele_use, param).then((res) => {
			resolve(res.data);
		});
	});
}
//下单充值
export function recharge(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.recharge, param).then((res) => {
			resolve(res.data);
		});
	});
}
//检验支付状态
export function checkStatus(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.checkStatus, param).then((res) => {
			resolve(res.data);
		});
	});
}

// axios2

//分层addBar 新版
export function shareDataList(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.shareDataList, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 提现列表新版
export function sm_order_fc_self(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.sm_order_fc_self, param).then((res) => {
			resolve(res.data);
		});
	});
}

//管理员添加备注
export function charge_remark(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.charge_remark, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 获取验证啊
export function alipay_code(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.alipay_code, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 是否需要绑定支付宝账号
export function read_alipay(param) {
	return new Promise((resolve, reject) => {
		axios2.get(api.read_alipay, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 保存支付宝账号
export function input_alipay(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.input_alipay, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 保存支付宝账号
export function apply_money(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.apply_money, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 提现记录

export function apply_money_rude(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.apply_money_rude, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 代理商列表
export function daili_list(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.daili_list, param).then((res) => {
			resolve(res.data);
		});
	});
}

//    查看公告
export function notice(param) {
	return new Promise((resolve, reject) => {
		axios2.get(api.notice, param).then((res) => {
			resolve(res.data);
		});
	});
}

//  订单列表
export function sm_order_list(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.sm_order_list, param).then((res) => {
			resolve(res.data);
		});
	});
}

//  查看首页的数据分成

export function sm_day_month_money(param) {
	return new Promise((resolve, reject) => {
		axios2.get(api.sm_day_month_money, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 查看图表
export function sm_fc_self_month(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.sm_fc_self_month, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 查看图表
export function sm_fc_self_scan(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.sm_fc_self_scan, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 创建代理商new_register
export function new_register(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.new_register, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 修改密码
export function set_pwd(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.set_pwd, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 登录
export function login(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.login, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 包月安装下载
export function sm_downloads(param) {
	return new Promise((resolve, reject) => {
		console.log(axios3);
		axios3.post(api.sm_downloads, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 渠道扫码
export function person_order(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.person_order, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 提现审核表

export function admin_apply_money_rude(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.admin_apply_money_rude, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 提现状态

export function admin_alipay_status(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.admin_alipay_status, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 获取qq
export function read_qq(param) {
	return new Promise((resolve, reject) => {
		axios2.get(api.read_qq, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 发送短信
export function apply_code(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.apply_code, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 注册

export function submit(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.submit, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 查看有效终端的列表数据
export function read_mac(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.read_mac, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 有效终端开关server_model.ChannelOpenClose
export function open_close(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.open_close, param).then((res) => {
			resolve(res.data);
		});
	});
}
//  查看昨天，今天，本月有效终端的数据
export function month_day_mac(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.month_day_mac, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 有效终端开关 默认
export function open_close_get(param) {
	return new Promise((resolve, reject) => {
		axios2.get(api.open_close, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 新版的 提现管理

export function new_agent_list_order(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.new_agent_list_order, param).then((res) => {
			resolve(res.data);
		});
	});
}
//包月分成
export function bar_order_fc(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.bar_order_fc, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 新版导出exe
export function sm_order_excel(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.sm_order_excel, param).then((res) => {
			resolve(res.data);
		});
	});
}
//扫码分成excl
export function bar_order_fc_excel(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.bar_order_fc_excel, param).then((res) => {
			resolve(res.data);
		});
	});
}
//包月分成excl
export function new_agent_list_order_excel(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.new_agent_list_order_excel, param).then((res) => {
			resolve(res.data);
		});
	});
}
// 查看msc记录
export function mac_fc_self(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.mac_fc_self, param).then((res) => {
			resolve(res.data);
		});
	});
}
//mac总和
export function self_sum_mac(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.self_sum_mac, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function add_bar_time(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.add_bar_time, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function read_gg_bar_time(param) {
	return new Promise((resolve, reject) => {
		axios2.get(api.read_gg_bar_time + "/" + param).then((res) => {
			resolve(res.data);
		});
	});
}
export function update_bar_num(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.update_bar_num, param).then((res) => {
			resolve(res.data);
		});
	});
}
//下载配置文件
export function downloadby_profile(param) {
	return new Promise((resolve, reject) => {
		axios3.get(api.downloadby_profile + param, param).then((res) => {
			resolve(res.data);
		});
	});
}

// 注意这个不一样哈  登录无需密码进入

export function noPasswordLogin(param) {
	return new Promise((resolve, reject) => {
		axios4.post(api.noPasswordLogin, param).then((res) => {
			resolve(res.data);
		});
	});
}

//分层
export function addBar(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.addBar, param).then((res) => {
			resolve(res.data);
		});
	});
}
//版本列表
export function versionRelease(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.versionRelease, param).then((res) => {
			resolve(res.data);
		});
	});
}
//添加版本

export function versionAdd(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.versionAdd, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function versionDownload(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.versionDownload, param).then((res) => {
			resolve(res.data);
		});
	});
}
//获取网吧id
export function barId(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.barId, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function accountNumber(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.accountNumber, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function bardel(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.bardel, param).then((res) => {
			resolve(res.data);
		});
	});
}

export function accountAll(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.accountAll, param).then((res) => {
			resolve(res.data);
		});
	});
}

export function changeBar(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.changeBar, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function firstMessage(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.firstMessage, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function getLineData(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.getLineData, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function getIndexInfos(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.getIndexInfos, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function admin_logs(param) {
	return new Promise((resolve, reject) => {
		axios2.get(api.admin_logs, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function getIndexMsg(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.getIndexMsg, param).then((res) => {
			resolve(res.data);
		});
	});
}
export function setIndexMsg(param) {
	return new Promise((resolve, reject) => {
		axios.post(api.setIndexMsg, param).then((res) => {
			resolve(res.data);
		});
	});
}

export function down(param) {
	return new Promise((resolve, reject) => {
		console.log(param);
		axios.post(api.down, param).then((res) => {
			resolve(res.data);
		});
	});
}
// // 添加文章
// export function AddArticle(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.AddArticle,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }
// // 审核人列表
// export function Examine(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.Examine,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }
// // 文章删除detailArticle
// export function deleArticle(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.deleArticle,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }
// // 文章删除
// export function detailArticle(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.detailArticle,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }
// // 修改密码
// export function changepassword(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.changepassword,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }
// // 用户反馈
// export function userBack(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.userBack,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }
// export function userBackDes(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.userBackDes,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }
// export function userBackDo(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.userBackDo,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }
// export function bussinessHandle(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.bussinessHandle,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }
export function getCode(param) {
	return new Promise((resolve, reject) => {
		console.log(param);
		axios.post(api.getCode, param).then((res) => {
			resolve(res.data);
		});
	});
}

export function refund_order(param) {
	return new Promise((resolve, reject) => {
		console.log(param);
		axios2.post(api.refund_order, param).then((res) => {
			resolve(res.data);
		});
	});
}

// export function memberType(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.memberType,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }
// export function shenhe(param){
//     return new Promise((resolve,reject)=>{
//         console.log(param);
//         axios.post(api.shenhe,param).then(res=>{
//             resolve(res.data)
//         })
//     })
// }

export function update_bar_name(param) {
	return new Promise((resolve, reject) => {
		axios2.post(api.update_bar_name, param).then((res) => {
			resolve(res.data);
		});
	});
}